import axios from 'axios';
import { TOKEN } from '../constants';
import { useNavigate } from 'react-router-dom';
import { ENV } from './envs';

const HEADERS = {
  'Content-Type': 'application/json',
};

const setupHttpClientInterceptors = (client) => {
  client.interceptors.request.use((config) => {
    let token = localStorage.getItem(TOKEN);
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  client.interceptors.response.use(
    (res) => {
      return Promise.resolve(res);
    },
    (error) => {
      if (error.response.status === 403) {
        useNavigate('/');
        window.location.reload();
      }
      return Promise.reject(error);
    }
  );
};

export const getCustomHttpClient = (headers = {}, axiosParams = {}, options = { shouldSetupInterceptors: true }, url = '') => {
  const client = axios.create({
    baseURL: `${ENV.baseUrl}${url || 'api/store/'}`,
    headers: {
      ...headers,
    },
    ...axiosParams,
  });

  if (options?.shouldSetupInterceptors) {
    setupHttpClientInterceptors(client);
  }

  return client;
};

export const HttpClient = getCustomHttpClient(HEADERS);

// export const AssetServiceHttpClient = getCustomHttpClient(HEADERS, {}, { shouldSetupInterceptors: true }, 'api/assetService/');
